import { Column, Paragraph, Row } from "@hex-insights/core";
import { Icon, IconContainer } from "@hex-insights/verita-romania.shared";
import styles from "./styles.module.css";

export function DataPrivacyStatement() {
	return (
		<Column justify="spaced-start" verticalSpacing="1rem">
			<span className={styles["bold-heading-text"]}>We take your privacy seriously</span>

			<Column justify="spaced-start">
				<Row justify="spaced-start" align="center" horizontalSpacing="1rem">
					<IconContainer color="var(--neutral-colors--stroke)" style={{ padding: "0.5rem" }}>
						<Icon.Gear size={24} color="var(--neutral-colors--tertiary)" />
					</IconContainer>

					<Paragraph className={styles["privacy-standard__text"]}>
						Collection and processing of your information is only used in the necessary operation of the school and this
						platform.
					</Paragraph>
				</Row>
				<Row justify="spaced-start" align="center" horizontalSpacing="1rem">
					<IconContainer color="var(--neutral-colors--stroke)" style={{ padding: "0.5rem" }}>
						<Icon.LockSimple size={24} color="var(--neutral-colors--tertiary)" />
					</IconContainer>

					<Paragraph className={styles["privacy-standard__text"]}>
						Records are stored securely and can only be accessed by authorized people.
					</Paragraph>
				</Row>
				<Row justify="spaced-start" align="center" horizontalSpacing="1rem">
					<IconContainer color="var(--neutral-colors--stroke)" style={{ padding: "0.5rem" }}>
						<Icon.Prohibit size={24} color="var(--neutral-colors--tertiary)" />
					</IconContainer>

					<Paragraph className={styles["privacy-standard__text"]}>We never sell your data to anyone.</Paragraph>
				</Row>
			</Column>
		</Column>
	);
}
